export default [
  {
    path: '/manager/view',
    name: 'manager-view',
    component: () => import('../views/manager/view.vue')
  },
   {
    path: '/manager/addnew/:id',
    name: 'manager-addnew-id',
    component: () => import('../views/manager/addnew.vue')
  }
]
